import { z } from "zod";

export const projectNameSchema = z
	.string()
	.min(1, "Please include a project name.")
	.min(5, "Please include more detail in your project name.")
	.max(100, "Project name must be 100 characters or less.");

export const projectDetailsSchema = z.object({
	projectName: projectNameSchema,
	brief: z.string().min(1, "Please include a brief for the project."),
	dueDate: z
		.string()
		.min(1, "Please select a deliver by date.")
		.refine((val) => {
			const selected = new Date(val);
			const tomorrow = new Date();
			tomorrow.setHours(0, 0, 0, 0);
			tomorrow.setDate(tomorrow.getDate() + 1);
			return selected >= tomorrow;
		}, "Due date must be tomorrow or later."),
});

export type ProjectDetailsForm = z.infer<typeof projectDetailsSchema>;
